import { RootState } from 'app/root-reducer';
import { useAppSelector } from 'app/hooks';
import ProgramContextHeader from "components/JobSeekerContextProvider/ProgramContextProvider/components/JobSeekerProgramContextHeader";
import JobSeekerProgramContextNavbar from "components/JobSeekerContextProvider/ProgramContextProvider/components/JobSeekerProgramContextNavbar";
import Footer from 'layout/common/Footer';
import './style.scss';

interface Props {
  children: React.ReactNode;
}

const JobSeekerProgramContextProvider: React.FC<Props> = ({ children }) => {
  const { selectedId: programContextSelectedId, data: { programDataIsLoading } } = useAppSelector((state: RootState) => state.selectedContext.programContext);
  return (
    <>
      {programContextSelectedId ?
        <div className="app-content container-fluid selected-program-context">
          <div className="program-context-header">
            <ProgramContextHeader programContextSelectedId={programContextSelectedId} programDataIsLoading={programDataIsLoading} />
            <JobSeekerProgramContextNavbar />
          </div>
          {children}
          <Footer />
        </div>
        :
        <>
          <div className="app-content container-fluid">
            {children}
          </div>
          <Footer />
        </>
      }
    </>
  );
};

export default JobSeekerProgramContextProvider;
